// ChartSetup.js
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, ArcElement, RadialLinearScale, Filler } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import gradient from "chartjs-plugin-gradient";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, ArcElement, RadialLinearScale, ChartDataLabels, gradient, Filler);

export default ChartJS;
